var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBCreator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 372,
    height: 372,
    viewBox: "0 0 372 372",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.846 98.9384L312.325 90.3848L320.97 99.0297L293.091 105.091C292.523 102.994 291.779 100.932 290.846 98.9384ZM300.178 78.2379L293.239 71.2986L280.775 85.8959C281.648 86.6261 282.498 87.3905 283.316 88.209C284.084 88.9763 284.802 89.7749 285.493 90.5906L300.178 78.2379ZM272.583 80.6759L281.137 59.1964L272.492 50.5515L266.431 78.4313C268.528 78.9989 270.59 79.7433 272.583 80.6759Z",
    fill: "#D3FB6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.1541 273.062L59.6746 281.615L51.0297 272.97L78.9095 266.909C79.4771 269.006 80.2215 271.068 81.1541 273.062ZM71.8217 293.762L78.761 300.701L91.2249 286.104C90.3521 285.374 89.5022 284.61 88.6836 283.791C87.9164 283.024 87.1976 282.225 86.5074 281.409L71.8217 293.762ZM99.4166 291.324L90.863 312.804L99.5079 321.448L105.569 293.569C103.472 293.001 101.41 292.257 99.4166 291.324Z",
    fill: "#D3FB6D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M186 371C288.173 371 371 288.173 371 186C371 83.8273 288.173 1 186 1C83.8273 1 1 83.8273 1 186C1 288.173 83.8273 371 186 371Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M150.008 150.014L105.271 266.732L221.989 221.996L266.726 105.278L150.008 150.014ZM185.999 201.141C177.589 201.141 170.862 194.414 170.862 186.005C170.862 177.596 177.589 170.869 185.999 170.869C194.408 170.869 201.135 177.596 201.135 186.005C201.135 194.414 194.408 201.141 185.999 201.141Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBCreator);
export default __webpack_public_path__ + "static/media/b_creator.57ac8948539b81727583593107eb8a37.svg";
export { ForwardRef as ReactComponent };